module.exports = __webpack_public_path__ + "img/Tessellate39.19ccabfd.jpg";